import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import Headings from "../Component/Measures/Headings";
import Card from "../Component/Measures/Card";
import Sorter from "../Component/Measures/Sorter";
import { useAuth } from "../Context/AuthContext";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentPage } from "../Redux/Actions/activePage";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import useWindowSize from "../Component/use-window-size";
import CardMobile from "../Component/Measures/CardMobile";
const Measures = () => {
  //get current windowsize
  const size = useWindowSize();
  const { measuresData, setMeasuresData, postLocalData } = useAuth();
  const [headingFocused, setHeadingFocused] = useState("");
  // const [sortedMeasuresData, setSortedMeasuresData] = useState();
  const [draggableOrder, setDraggableOrder] = useState(measuresData);
  // const [isOldestFirst, setIsOldestFirst] = useState(true);
  const [orderBy] = useState("ASC");
  const [input] = useState({
    costs1: 0,
    costs2: 0,
    costs3: 0,
    enddate: "",
    hours1: 0,
    hours2: 0,
    hours3: 0,
    measureName: "",
    priority: "3",
    responsible: "",
    startdate: "",
  });

  //redux
  const dispatch = useDispatch();
  const sizeForMobile = useSelector((state) => state.sizeForMobile.size);

  function submitHandler() {
    postLocalData(input);
  }

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      const setRowsIfMissing = measuresData?.measuresData?.map(
        (item) => item
      ).length;
      if (setRowsIfMissing < 1) {
        const delayEditData = setTimeout(() => {
          postLocalData(input);
        }, 500);
        return () => clearTimeout(delayEditData);
      }
    }
    return () => {
      isMounted = false;
    };
  }, [measuresData, input, postLocalData]);

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      dispatch(setCurrentPage("Åtgärder"));
    }
    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  const toggleSort = (str) => {
    // setIsOldestFirst(!isOldestFirst);
    //receive str argument to enter corresponding function
    if (str === "measureName") {
      sortByMeasureName();
    } else if (str === "prio") {
      sortByPriority();
    } else if (str === "responsible") {
      sortByResponsible();
    } else if (str === "costs1") {
      sortByCostsYear1();
    } else if (str === "costs2") {
      sortByCostsYear2();
    } else if (str === "costs3") {
      sortByCostsYear3();
    } else if (str === "hours1") {
      sortByHoursYear1();
    } else if (str === "hours2") {
      sortByHoursYear2();
    } else if (str === "hours3") {
      sortByHoursYear3();
    } 
    // else if (str === "startdate") {
    //   sortByDate();
    // }
  };

  //str.charAt(0).toUpperCase() + str.slice(1);
  //must capitalize or minimize first letter or else sort wont work
  function sortByMeasureName() {
    const newList = [...measuresData.measuresData];
    if (orderBy === "ASC") {
      newList
        ?.sort((a, b) => (a.object.measureName < b.object.measureName ? -1 : 1))
        .map((item) => item.object.measureName);
      setDraggableOrder({ measuresData: newList });
      setMeasuresData({ measuresData: newList });
    } else if (orderBy === "DESC") {
      newList
        ?.sort((a, b) => (a.object.measureName > b.object.measureName ? -1 : 1))
        .map((item) => item.object.measureName);
      setDraggableOrder({ measuresData: newList });
      setMeasuresData({ measuresData: newList });
    }
  }
  function sortByPriority() {
    const newList = [...measuresData.measuresData];
    if (orderBy === "ASC") {
      newList
        ?.sort((a, b) => (a.object.priority < b.object.priority ? -1 : 1))
        .map((item) => item.object.priority);
      setDraggableOrder({ measuresData: newList });
      setMeasuresData({ measuresData: newList });
    } else if (orderBy === "DESC") {
      newList
        ?.sort((a, b) => (a.object.priority > b.object.priority ? -1 : 1))
        .map((item) => item.object.priority);
      setDraggableOrder({ measuresData: newList });
      setMeasuresData({ measuresData: newList });
    }
  }
  function sortByResponsible() {
    const newList = [...measuresData.measuresData];
    if (orderBy === "ASC") {
      newList
        ?.sort((a, b) => (a.object.responsible < b.object.responsible ? -1 : 1))
        .map((item) => item.object.responsible);
      setDraggableOrder({ measuresData: newList });
      setMeasuresData({ measuresData: newList });
    } else if (orderBy === "DESC") {
      newList
        ?.sort((a, b) => (a.object.responsible > b.object.responsible ? -1 : 1))
        .map((item) => item.object.responsible);
      setDraggableOrder({ measuresData: newList });
      setMeasuresData({ measuresData: newList });
    }
  }

  function sortByCostsYear1() {
    const newList = [...measuresData.measuresData];
    if (orderBy === "ASC") {
      newList
        ?.sort((a, b) =>
          parseFloat(a.object.costs1) < parseFloat(b.object.costs1) ? -1 : 1
        )
        .map((item) => item.object.costs1);
      setDraggableOrder({ measuresData: newList });
      setMeasuresData({ measuresData: newList });
    } else if (orderBy === "DESC") {
      newList
        ?.sort((a, b) =>
          parseFloat(a.object.costs1) > parseFloat(b.object.costs1) ? -1 : 1
        )
        .map((item) => item.object.costs1);
      setDraggableOrder({ measuresData: newList });
      setMeasuresData({ measuresData: newList });
    }
  }
  function sortByCostsYear2() {
    const newList = [...measuresData.measuresData];
    if (orderBy === "ASC") {
      newList
        ?.sort((a, b) =>
          parseFloat(a.object.costs2) < parseFloat(b.object.costs2) ? -1 : 1
        )
        .map((item) => item.object.costs2);
      setDraggableOrder({ measuresData: newList });
      setMeasuresData({ measuresData: newList });
    } else if (orderBy === "DESC") {
      newList
        ?.sort((a, b) =>
          parseFloat(a.object.costs2) > parseFloat(b.object.costs2) ? -1 : 1
        )
        .map((item) => item.object.costs2);
      setDraggableOrder({ measuresData: newList });
      setMeasuresData({ measuresData: newList });
    }
  }
  function sortByCostsYear3() {
    const newList = [...measuresData.measuresData];
    if (orderBy === "ASC") {
      newList
        ?.sort((a, b) =>
          parseFloat(a.object.costs3) < parseFloat(b.object.costs3) ? -1 : 1
        )
        .map((item) => item.object.costs3);
      setDraggableOrder({ measuresData: newList });
      setMeasuresData({ measuresData: newList });
    } else if (orderBy === "DESC") {
      newList
        ?.sort((a, b) =>
          parseFloat(a.object.costs3) > parseFloat(b.object.costs3) ? -1 : 1
        )
        .map((item) => item.object.costs3);
      setDraggableOrder({ measuresData: newList });
      setMeasuresData({ measuresData: newList });
    }
  }

  function sortByHoursYear1() {
    const newList = [...measuresData.measuresData];
    if (orderBy === "ASC") {
      newList
        ?.sort((a, b) =>
          parseFloat(a.object.hours1) < parseFloat(b.object.hours1) ? -1 : 1
        )
        .map((item) => item.object.hours1);
      setDraggableOrder({ measuresData: newList });
      setMeasuresData({ measuresData: newList });
    } else if (orderBy === "DESC") {
      newList &&
        newList
          .sort((a, b) =>
            parseFloat(a.object.hours1) > parseFloat(b.object.hours1) ? -1 : 1
          )
          .map((item) => item.object.hours1);
      setDraggableOrder({ measuresData: newList });
      setMeasuresData({ measuresData: newList });
    }
  }
  function sortByHoursYear2() {
    const newList = [...measuresData.measuresData];
    if (orderBy === "ASC") {
      newList
        ?.sort((a, b) =>
          parseFloat(a.object.hours2) < parseFloat(b.object.hours2) ? -1 : 1
        )
        .map((item) => item.object.hours2);
      setDraggableOrder({ measuresData: newList });
      setMeasuresData({ measuresData: newList });
    } else if (orderBy === "DESC") {
      newList &&
        newList
          .sort((a, b) =>
            parseFloat(a.object.hours2) > parseFloat(b.object.hours2) ? -1 : 1
          )
          .map((item) => item.object.hours2);
      setDraggableOrder({ measuresData: newList });
      setMeasuresData({ measuresData: newList });
    }
  }
  function sortByHoursYear3() {
    const newList = [...measuresData.measuresData];
    if (orderBy === "ASC") {
      newList
        ?.sort((a, b) =>
          parseFloat(a.object.hours3) < parseFloat(b.object.hours3) ? -1 : 1
        )
        .map((item) => item.object.hours3);
      setDraggableOrder({ measuresData: newList });
      setMeasuresData({ measuresData: newList });
    } else if (orderBy === "DESC") {
      newList
        ?.sort((a, b) =>
          parseFloat(a.object.hours3) > parseFloat(b.object.hours3) ? -1 : 1
        )
        .map((item) => item.object.hours3);
      setDraggableOrder({ measuresData: newList });
      setMeasuresData({ measuresData: newList });
    }
  }
  // function sortByDate() {
  //   console.log("date");
  //   const newList = [...measuresData.measuresData];
  //   if (orderBy === "ASC") {
  //     newList
  //       ?.sort((a, b) => (a.object.startdate < b.object.startdate ? -1 : 1))
  //       .map((item) => item.object.startdate);
  //     setDraggableOrder({ startdate: newList });
  //     setMeasuresData({ startdate: newList });
  //     // } else if (orderBy === "DESC") {
  //     //   newList
  //     //     ?.sort((a, b) => (a.object.startdate > b.object.startdate ? -1 : 1))
  //     //     .map((item) => item.object.startdate);
  //     //   setDraggableOrder({ startdate: newList });
  //     //   setMeasuresData({ startdate: newList });
  //   }
  // }
  function handleOnDragEnd(result) {
    if (!result.destination) return;
    const items = Array.from(draggableOrder.measuresData);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setDraggableOrder({ measuresData: items });
    setMeasuresData({ measuresData: items });
  }

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      setDraggableOrder(measuresData);
    }
    return () => {
      isMounted = false;
    };
  }, [measuresData]);

  return (
    <Row>
      <Col xs={40} className="m-auto g-0">
        {size.width < 1024 ? "" : <Sorter toggleSort={toggleSort} />}
        {size.width < 1024 ? "" : <Headings headingFocused={headingFocused} />}
        <div className={size.width < 1024 ? "scrollbox-mobile" : "scrollbox"}>
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="cardOrder">
              {(provided) => (
                <div
                  className="content-wrapper"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {draggableOrder?.measuresData?.map((card, index) => (
                    <Draggable
                      key={card.id}
                      draggableId={card.id}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          ref={provided.innerRef}
                        >
                          {size.width < sizeForMobile ? (
                            <CardMobile data={card} />
                          ) : (
                            <Card
                              data={card}
                              setHeadingFocused={setHeadingFocused}
                            />
                          )}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
        <div
          className="container-buttons-below-scrollbox"
          style={{ marginTop: "2%", marginRight: "5%" }}
        >
          <div className="button-add-row" onClick={submitHandler}>
            <p className="plus">+</p>
          </div>
        </div>
      </Col>
    </Row>
  );
};
export default Measures;
